import { parsePhoneNumberWithError } from "libphonenumber-js";
import { COUNTRY_CODES } from "#lib/components/flow/editor/builder/properties/external/constants.js";

export function formatPhoneNumber(phoneNumber: string): string {
	if (phoneNumber === "") {
		return "";
	}
	try {
		const result = parsePhoneNumberWithError(phoneNumber, "US");
		if (!result.isValid()) {
			// check if they forgot + sign before country code
			if (!phoneNumber.startsWith("+") && validatePhoneNumber(`+${phoneNumber}`)) {
				return formatPhoneNumber(`+${phoneNumber}`);
			}
		}
		if (result.country === "US") return result.formatNational();
		return result.formatInternational();
	} catch {
		return phoneNumber;
	}
}

export function normalizePhoneNumber(phoneNumber: string): string {
	if (phoneNumber === "") {
		return "";
	}
	try {
		const result = parsePhoneNumberWithError(phoneNumber, "US");
		if (!result.isValid()) {
			return phoneNumber;
		}
		return result.number;
	} catch {
		return phoneNumber;
	}
}

export function validatePhoneNumber(phoneNumber: string): boolean {
	try {
		if (validateShortCode(phoneNumber)) return true;
		const result = parsePhoneNumberWithError(phoneNumber, "US");
		return result.isValid();
	} catch {
		return false;
	}
}

function validateShortCode(phoneNumber: string): boolean {
	return /^\d{5,6}$/.test(phoneNumber);
}

export function getCountryCodeFromNumber(phoneNumber: string): string | undefined {
	if (phoneNumber === "") {
		return undefined;
	}
	try {
		const result = parsePhoneNumberWithError(phoneNumber, "US");
		if (result.countryCallingCode) {
			return `+${result.countryCallingCode}`;
		}
	} catch {
		return undefined;
	}
	return undefined;
}

export function getCountryCodeIconFromCountryCode(countryCode: string | undefined): string {
	if (!countryCode) {
		return "";
	}
	return COUNTRY_CODES.find(option => option.value === countryCode)?.iconName ?? "";
}
